import { createEffect, createMemo, createSignal, Show, type ParentProps } from "solid-js"
import { useLocation } from "@solidjs/router"
import { DashboardLoadingScreen } from "@/components/dashboard-loading-screen"
import { useFleet } from "@/context/fleet"

/**
 * Only a cold start on Machines waits for the fleet, so first-run setup does not
 * flash. Cached machines render at once, and once the shell has mounted it is
 * never torn down again (navigating to Machines mid-load must not remount it).
 */
export function MachinesStartupGate(props: ParentProps) {
  const location = useLocation()
  const fleet = useFleet()
  const machinesPage = createMemo(() => location.pathname.replace(/\/+$/, "") === "/dashboard/machines")
  const cold = () => machinesPage() && fleet.machines.loading && (fleet.machines()?.length ?? 0) === 0
  const [mounted, setMounted] = createSignal(false)
  const ready = () => mounted() || !cold()
  createEffect(() => {
    if (ready()) setMounted(true)
  })
  return (
    <Show when={ready()} fallback={<DashboardLoadingScreen label="Loading your machines" />}>
      {props.children}
    </Show>
  )
}
